"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const debug_pill_1 = __importDefault(require("./debug-pill"));
const shadow_1 = __importDefault(require("../primitives/shadow"));
const react_1 = __importDefault(require("react"));
const debug_provider_1 = require("./debug-provider");
const react_2 = require("@emotion/react");
const big_svg_1 = __importDefault(require("./big-svg"));
const small_svg_1 = __importDefault(require("./small-svg"));
const drawer_1 = require("../primitives/drawer");
const DebugWidget = ({ id, update }) => {
    const [visible, setVisible] = react_1.default.useState(false);
    const show = (0, debug_provider_1.useDebug)();
    return (react_1.default.createElement(shadow_1.default, null,
        react_1.default.createElement(react_2.ClassNames, null, ({ css }) => (react_1.default.createElement("div", null,
            react_1.default.createElement("div", { style: {
                    position: 'fixed',
                    bottom: '20px',
                    right: '20px',
                    padding: '4px',
                    fontSize: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: '0.3s',
                    zIndex: 10000,
                } },
                react_1.default.createElement("div", { className: css({
                        backgroundColor: "#008739",
                        color: "#fff",
                        borderRadius: '500px',
                        padding: '6px',
                        width: '60px',
                        height: '60px',
                        boxShadow: "0 0 8px #0006"
                    }), onClick: () => {
                        setVisible(!visible);
                    } },
                    react_1.default.createElement(small_svg_1.default, null))),
            react_1.default.createElement(drawer_1.DrawerContent, { open: visible, placement: "right", size: "md", animation: "slide" },
                react_1.default.createElement("div", { className: css({
                        padding: '20px'
                    }) },
                    react_1.default.createElement("div", { className: css({
                            borderBottom: `1px solid #fff1`,
                            color: '#fff',
                            paddingBottom: '20px'
                        }) },
                        react_1.default.createElement(big_svg_1.default, null)),
                    id && react_1.default.createElement("div", { style: {
                            marginBottom: '2px',
                            borderBottom: `1px solid #fff1`,
                            padding: '20px 0'
                        } },
                        react_1.default.createElement("a", { href: `/api/gatsby-plugin-atollon/get-editing-url?id=${id}` },
                            react_1.default.createElement(debug_pill_1.default, { style: {
                                    boxShadow: '0 0 8px #0004',
                                    backgroundColor: 'red',
                                } }, "Edit Page"))),
                    Object.entries(show).map(([key, val]) => (react_1.default.createElement("div", { style: {
                            marginBottom: '2px',
                            borderBottom: `1px solid #fff1`,
                            padding: '20px 0'
                        } },
                        react_1.default.createElement("button", { style: {
                                backgroundColor: val ? 'green' : 'black',
                                color: '#fff',
                                padding: '4px 10px',
                                borderRadius: '3px',
                                transition: '0.2s',
                                fontSize: '12px',
                            }, onClick: () => {
                                update(key);
                            } },
                            key,
                            ":",
                            val.toString())))))))))));
};
exports.default = DebugWidget;
//# sourceMappingURL=debug-widget.js.map